export enum TransferStatusEnum {
    IN_TRANSIT = 'IN TRANSIT',
    RECEIVED = 'RECEIVED'
}